import * as actions from '../actions/';
import { IReportState } from '../state/IReportState';

export const initialState: IReportState = {
  ssrsConfig: undefined,
  ssrsReportCategories: []
}

export function reportStateReducer(state = initialState, action: actions.Actions): IReportState {
  switch (action.type) {
    case actions.GET_SSRS_CONFIG_SUCCESS:
      return {
        ...state,
        ssrsConfig: (action as actions.GetSsrsConfigSuccessAction).payload
      };
    case actions.GET_REPORTS_QUERY_SUCCESS:
      return {
        ...state,
        ssrsReportCategories: (action as actions.GetReportsQuerySuccessAction).payload.items
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/report/store/reducers/reports-reducer.ts